module.exports = __webpack_public_path__ + "img/Paessler-NetFlow.88f55be.svg";